import axios, { AxiosInstance, AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';

import { ServerError } from './Error.ts';

export default class Api {
    axios: AxiosInstance;

    constructor() {
        this.axios = axios.create({
            headers: {
                'Content-type': 'application/json',
            },
        });

        this.initialize();
    }

    async initialize() {
        try {
            const { data } = await axios.get('/Tapu/AppSetting.json');
            const sessionUrl = sessionStorage.getItem('Url');
            const url = sessionUrl ?? data.Service;
            const baseUrl = process.env.NODE_ENV === 'development' ? "http://192.168.1.201:9510/" : (url ?? "/")
            this.axios = axios.create({
                baseURL: baseUrl,
                headers: {
                    'Content-type': 'application/json',
                },
            });

            this.init();
        } catch (error) {
            console.error("Error while initializing API:", error);
        }
    }

    init() {
        this.axios.interceptors.request.use(this.onRequest.bind(this));
        this.axios.interceptors.response.use(this.onSuccess.bind(this), this.onFailed.bind(this));
    }

    onRequest(config: AxiosRequestConfig): AxiosRequestConfig {
        const userName = sessionStorage.getItem('userName');
        config.data = {
            userName: userName,
            ...config.data,
        };
        return config;
    }

    onSuccess(response: AxiosResponse): AxiosResponse {
        if (response.data !== null && response.data !== undefined) {
            if (typeof (response.data) === 'string') {
                throw new ServerError(response.data);
            }
            return response.data;
        }
        throw new ServerError();
    }

    onFailed(error: AxiosError | any): Error {
        if (error.response) {
            throw new ServerError(error.response.data?.Message);
        }

        throw new ServerError("Beklenmedik bir hata oluştu");

    }
}
/* eslint-enable */
